import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MapPinIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const FIRST_DELAY = 5000;
const VISIBLE_MS = 6000;
const HIDDEN_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timeout = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentBuyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_MS : index === 0 ? FIRST_DELAY : HIDDEN_MS);
    return () => window.clearTimeout(timeout);
  }, [visible, index, dismissed]);
  const buyer = recentBuyers[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-2.5 left-2.5 z-50 max-w-[15.5rem]" data-id="element-141" data-mp="1gx2t254uzpug">
      <AnimatePresence data-id="element-142" data-mp="1175xy7vo5aih">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="pointer-events-auto flex items-start gap-2 rounded-xl border-2 border-field bg-gold p-2 text-pitch shadow-xl ring-[3px] ring-pitch" data-id="element-143" data-mp="116mjj1589497">
            <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-field" data-id="element-144" data-mp="x5153bd1ohww">
              <CheckIcon size={12} className="text-white" strokeWidth={3.5} data-id="element-145" data-mp="s5yc4paca25a" />
            </span>
            <div className="min-w-0" data-id="element-146" data-mp="28joki88hrckq">
              <p className="text-xs font-bold leading-snug" data-id="element-147" data-mp="28imw722gstl2">
                {buyer.name} compró el Mega Pack Entrenador de Fútbol – De Cero a Profesional
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold leading-snug" data-id="element-148" data-mp="2anjkljjmyf9e">
                <MapPinIcon size={10} className="flex-shrink-0 text-field" data-id="element-149" data-mp="2fmmqf67fwpif" />
                {buyer.city}, Argentina · hace {buyer.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="flex-shrink-0 rounded p-0.5 text-pitch/70 transition-colors duration-150 ease-out hover:text-pitch" data-id="element-150" data-mp="2pmdkx7w034ii">
              <XIcon size={12} data-id="element-151" data-mp="21w9hp1mq56s1" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}